import { NgModule } from "@angular/core";
import { CommonModule, Location } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ReactiveFormsModule, FormBuilder } from "@angular/forms";

import { MyDeqErrorHandler } from "./errorHandler";

import { USPSCleanAddressComponent } from "./usps-clean-address/usps-clean-address.component";
import { PlaceService } from "./service/place.service";
import { Utils } from "./Utils";

@NgModule({
  imports: [CommonModule, RouterModule, ReactiveFormsModule],
  declarations: [USPSCleanAddressComponent],
  exports: [USPSCleanAddressComponent],

  providers: [MyDeqErrorHandler, Location, PlaceService, Utils],
})
export class CleanAddressModule {}
